namespace Solovis.Reports.Parameters {

    export class PropertyParameterControl extends Solovis.UI.BaseControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        public settings;
        public filter;
        public initialParameterValue;
        public currentProperty;

        private selectedPropertyLabel;
        private selectPropertyLink;
        private _selectionDialog: Solovis.UI.Dialog;
        private _propertyDefs;

        static hasNewRender = true;

        constructor(options) {
            super(options);

            this._portalServices = options.portalServices;

            this.settings = options.settings ? options.settings : {};
            this.filter = this.settings.filter ? this.settings.filter : {};

            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : false;
            this.currentProperty = this.initialParameterValue;
        }


        public static preload(newValue, callback, portalServices: Solovis.Portal.IPortalServices) {
            var self = this;
            if (newValue && (newValue.id || newValue.code)) {
                let propDefRequest: any = {};
                if (newValue.id) {
                    propDefRequest.id = newValue.id;
                }
                else if (newValue.code) {
                    propDefRequest.code = newValue.code;
                }

                portalServices.rpc().invoke(
                    "~/Selectors/PropertySelector/GetPropertyData", propDefRequest,
                    function (response, success) {
                        if (success) {
                            var propertyData = response.result;
                            callback(propertyData, true);
                        }
                        else {
                            callback(null, false);
                        }
                    });
            }
            else {
                callback(null, true);
            }
        }

        public static shouldPreload(value) {
            if (!value || (value.id && value.label)) {
                // Already loaded.
                return false;
            }

            return true;
        }

        public static serializeParameterValue(value): any {
            if (value) {
                if (value.id) {
                    return { id: value.id };
                }
                else if (value.code) {
                    return { code: value.code };
                }
            }

            return null;
        }

        public static getLabel(value): string | undefined {
            return value?.label;
        }

        public doRender() {
            if (this.options.renderMode === 'modern') {
                this.doRenderNew();
            } else {
                this.doRenderClassic();
            }
        }

        public doRenderClassic() {
            var self = this;

            this.selectedPropertyLabel = $("<a>").appendTo(this.container)
                .click(function (e) {
                    if (self.currentProperty && self.currentProperty.id) {
                        Solovis.UI.PopupLinkPanel.showLinks({
                            offset: { left: e.pageX, top: e.pageY },
                            links: Solovis.Reports.ReportLinker.getPropertyLinks(self.currentProperty.id)
                        });
                    }
                });
            this.selectPropertyLink = $("<a>").html("<span class='fa fa-pencil'></span>").appendTo(this.container);

            this.selectPropertyLink.click(function () {
                self._toggleSelectorDialog(function (property) {
                    self._setCurrentPropertyData(property);
                    self.notifyParameterValueChanged();
                });
            });

            // Set initial parameter value text.
            if (this.currentProperty) {
                this._setCurrentPropertyData(this.currentProperty);
            }

            // Setup drop handler for Solovis reference.
            Solovis.Site.DragDropManager.setupSolovisRefDrop(this.container, function (solovisRef) {
                if (solovisRef.type == "property") {
                    self.setParameterValue(solovisRef.value);
                }
            });
        }

        public async doRenderNew() {
            var self = this;
            const target = this.container[0];
            const { fetchPropertyDefinitions } = await (window as any).importShim('@solovis/pa-utils');

            await Solovis.UX.Utils.placeComponent(
                "PropertyParameterControl",
                target,
                {
                    cacheOptions: true,
                    defaultValue: (self.options as any).initialValue || undefined,
                    loadOptions: () => new Promise(async (resolve, reject) => {
                        if (self._propertyDefs) {
                            return resolve(self._propertyDefs)
                        }

                        try {
                            const options = await fetchPropertyDefinitions()
                            self._propertyDefs = options;
                            resolve(options)
                        } catch (e) {
                            reject(e);
                        }
                    }),
                    onChange: (selectedItem) => {
                        this.currentProperty = selectedItem;
                        self.notifyParameterValueChanged();
                    }
                }
            );
        }


        public _setCurrentPropertyData(propertyData) {
            this.currentProperty = propertyData;
            if (this.currentProperty) {
                this.selectedPropertyLabel.text(PropertyParameterControl.getLabel(this.currentProperty) + " ");
            }
            else {
                this.selectedPropertyLabel.text("");
            }
        };

        public setParameterValue(newValue, more?) {
            Solovis.Reports.Parameters.ParameterControlHelper.handleSetParameterValue(
                this, PropertyParameterControl, this._setCurrentPropertyData, newValue, more);
        }

        public getParameterValue() {
            if (this.state < Solovis.UI.BaseControl.ControlState.afterInit) {
                return this.initialParameterValue ? this.initialParameterValue : null;
            }
            else if (this.currentProperty) {
                return Solovis.deepCopy(this.currentProperty);
            }
            else {
                return null;
            }
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }

        public _toggleSelectorDialog(selectionCallback) {
            var self = this;

            if (this._selectionDialog) {
                // We already have the selection dialog open, so close it.
                this._selectionDialog.close();
                this._selectionDialog = null;
                return;
            }


            var selectorControlHostDiv = $("<div>");
            var selectorControlHost = new Solovis.UI.ControlHost({ container: selectorControlHostDiv });
            var selectorControl = new Solovis.InvDataSelectors.PropertySelectorControl({
                controlHost: selectorControlHostDiv,

                portalServices: this._portalServices,

                initialValue: this.currentProperty,

                settings: this.settings,

                selectionCallback: function (property) {
                    selectionCallback(property);
                    self._selectionDialog.close();
                },

                cancelCallback: function () {
                    self._selectionDialog.close();
                }
            });
            selectorControlHost.setCurrentControl(selectorControl);

            // Determine dialog position.        
            var linkOffset = $(this.selectedPropertyLabel).offset();
            var linkHeight = $(this.selectPropertyLink).outerHeight();
            var dialogPosition = {
                left: linkOffset.left,
                top: linkOffset.top + linkHeight + 5
            };

            var adjustedPosition = Solovis.UI.Dialog.autoAdjustSizeAndPosToViewport(dialogPosition, { width: 350, height: 150 });

            var desiredWidth = Math.min($(window).width() * .8, 250);
            var desiredHeight = Math.min($(window).height() * .8, 300);

            var minWidth = 100;
            var minHeight = 100;

            this._selectionDialog = new Solovis.UI.Dialog({
                container: selectorControlHostDiv,
                ownerDialog: Solovis.UI.Dialog.findContainingDialog(this.container),

                title: false,
                autoOpen: true,
                destroyOnClose: true,
                actions: ["Close"],
                noAnimation: true,
                position: adjustedPosition,
                width: desiredWidth,
                minWidth: minWidth,
                minHeight: minHeight,
                height: desiredHeight,

                buttons: [
                    {
                        label: "Clear",
                        click: function () {
                            selectionCallback(null);
                            self._selectionDialog.close();
                        }
                    },
                    {
                        label: "Cancel",
                        click: function () {
                            self._selectionDialog.close();
                        }
                    }
                ],

                activate: function () {
                    var overallHeight = this.getAvailableContentHeight();
                    selectorControl.setAvailableHeight(overallHeight);
                    selectorControl.focus();
                },

                resize: function () {
                    var overallHeight = this.getAvailableContentHeight();
                    selectorControl.setAvailableHeight(overallHeight);
                },

                deactivate: function () {
                    self._selectionDialog = null;
                }
            });
        }
    }

}
